import React, { useEffect, useState } from 'react'
import { FaSearch, FaBuilding } from 'react-icons/fa'
import { FaArrowRightLong } from 'react-icons/fa6'
import { Link } from 'react-router-dom'
import GlobalSearch from '../components/GlobalSearch'
import secureLocalStorage from 'react-secure-storage'
import axios from 'axios'


const Skeleton = ({ number }) => {
    return (
        [...Array(number)].map((_, index) => (
            <div className='col-lg-6 col-md-6 col-12'>
                <div class="skeleton-card">
                    <div class="skeletonasd avatar-skeleton"></div>
                    <div class="skeletonasd text-skeleton short"></div>
                    <div class="skeletonasd text-skeleton medium"></div>
                    <div class="skeletonasd text-skeleton full"></div>
                    <div class="skeletonasd text-skeleton full"></div>
                    <div class="skeletonasd btn-skeleton"></div>
                </div>
            </div>
        ))
    );
};



function Group() {
    const auth = JSON.parse(secureLocalStorage.getItem('auth_data'));
    const [groups, setGroup] = useState(null);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [activeTab, setActiveTab] = useState('all');

    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [memberCounts, setMemberCounts] = useState({});

    const fetchMemberCounts = async (groupsData) => {
        if (!groupsData?.length) return;
        groupsData.forEach(group => {
            axios.get(`https://buzzinguniverse.com/backend/api/groups/all-members?group_id=${group.id}&page=1`)
                .then(res => {
                    setMemberCounts(prev => ({ ...prev, [group.id]: res.data?.data?.total || 0 }));
                })
                .catch(() => {});
        });
    };

    const fetchGroup = async (page, e) => {
        e && e.preventDefault();
        setLoading(true);
        try {
            // Build query params
            let queryParams = `search=${search}&page=${page}`;

            // Add type filter based on active tab
            if (activeTab === 'groups') {
                queryParams += '&type=group';
            } else if (activeTab === 'companies') {
                queryParams += '&type=company';
            }
            // If activeTab is 'all', don't add type param to get all

            const res = await axios.get(`https://buzzinguniverse.com/backend/api/groups/get?${queryParams}`);
            setGroup(res.data?.data || null);
            setCurrentPage(res.data?.data.current_page);
            setLastPage(res.data?.data.last_page);
            fetchMemberCounts(res.data?.data?.data);
        } catch (err) {
            console.error("Failed to fetch group:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGroup(currentPage);
        window.scrollTo(0, 100);
    }, [currentPage]);

    // Refetch when tab changes
    useEffect(() => {
        setCurrentPage(1);
        fetchGroup(1);
    }, [activeTab]);

    const handlePageChange = (page) => {
        if (page !== currentPage && page >= 1 && page <= lastPage) {
            setCurrentPage(page);
        }
    };

    const renderPagination = () => {
        if (lastPage <= 1) return null;
        const pages = [];
        for (let i = 1; i <= lastPage; i++) {
            pages.push(
                <li key={i} className={i === currentPage ? "active" : ""}>
                    <button onClick={() => handlePageChange(i)}>{i}</button>
                </li>
            );
        }
        return <ul className="pagination">{pages}</ul>;
    };


    return (
        <div>
            <GlobalSearch />

            <div className="inner-groups-pages-link-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <ul>
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/about">About Us</Link></li>
                                <li><Link to="/faqs">FAQs </Link></li>
                                <li><Link to="/blogs">Blog</Link></li>
                                <li><Link to="/contact">Contact</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <section>
                <div className="inner-groups-sec">
                    <div className="container">
                        <div className="row" style={{ justifyContent: 'center' }}>
                            <div className="col-lg-7 col-12">
                                <div className="inner-groups-box">
                                    <div className="all-groups">
                                        <ul>
                                            <li><p>{activeTab === 'groups' ? 'All Groups' : activeTab === 'companies' ? 'All Companies' : 'All Groups & Companies'}</p></li>
                                            <li><span>{groups?.total || 0}</span></li>
                                        </ul>
                                        {auth && <Link to="/create-company" className='btncs'>
                                            <i className="fa fa-plus me-2"></i>
                                            Create {activeTab === 'groups' ? 'Group' : activeTab === 'companies' ? 'Company' : 'New'}
                                        </Link>}
                                    </div>

                                    {/* Filter Tabs */}
                                    <div className="group-filter-tabs mb-3">
                                        <button
                                            className={`filter-tab-btn ${activeTab === 'all' ? 'active' : ''}`}
                                            onClick={() => setActiveTab('all')}
                                        >
                                            <i className="fa fa-th-large me-2"></i>
                                            All
                                        </button>
                                        <button
                                            className={`filter-tab-btn ${activeTab === 'groups' ? 'active' : ''}`}
                                            onClick={() => setActiveTab('groups')}
                                        >
                                            <i className="fa fa-users me-2"></i>
                                            Groups
                                        </button>
                                        <button
                                            className={`filter-tab-btn ${activeTab === 'companies' ? 'active' : ''}`}
                                            onClick={() => setActiveTab('companies')}
                                        >
                                            <i className="fa fa-building me-2"></i>
                                            Companies
                                        </button>
                                    </div>

                                    <div className="search-groups-row">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 col-12">
                                                <div className="search-groups-box">
                                                    <form onSubmit={(e) => fetchGroup(1, e)}>
                                                        <input type="text" onChange={(e) => setSearch(e.target.value)} placeholder="Search Groups..." />
                                                        <div className="search-groups-box-icon">
                                                            <button type="submit"><FaSearch /></button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="search-groups-boxs-row">
                                        <div className="row">
                                            {loading ? (
                                                <Skeleton number={6} />
                                            ) : groups?.data && groups.data.length > 0 ? (
                                                groups.data.filter((group) => group.admins && group.admins.length > 0).map((group) => {
                                                const isCompany = group.type === 'company';
                                                const entityLabel = isCompany ? 'Company' : 'Group';
                                                return (
                                                <div key={group.id} className="col-lg-6 col-md-6 col-12">
                                                    <div className="search-groups-boxs">
                                                        <div className="search-groups-box-back" style={{
                                                            backgroundImage: `url(https://buzzinguniverse.com/backend/${group.cover_photo}), radial-gradient(circle, rgb(153 153 153) 0%, rgba(0, 0, 0, 0.15) 58%, rgba(0, 0, 0, 0.3) 100%)`
                                                        }} />
                                                        <span>
                                                            {group.profile_picture ? (
                                                                <img
                                                                    src={`https://buzzinguniverse.com/backend/${group.profile_picture}`}
                                                                    alt={group.name}
                                                                />
                                                            ) : isCompany ? (
                                                                <div className="company-icon-placeholder">
                                                                    <FaBuilding />
                                                                </div>
                                                            ) : (
                                                                <img
                                                                    src="/images/mystery-group.png"
                                                                    alt={group.name}
                                                                />
                                                            )}
                                                        </span>
                                                        <h2>
                                                            {isCompany && group.url
                                                                ? <a href={group.url} target="_blank" rel="noopener noreferrer">{group.name}</a>
                                                                : <Link to={`/company/${group.id}/${encodeURIComponent(group.name.replace(/\s+/g, '-').toLowerCase())}`}>{group.name}</Link>
                                                            }
                                                        </h2>
                                                        <strong>Active 6 hours ago</strong>
                                                        <div className='adminslist-adf'>
                                                            {
                                                                group.admins && group.admins.map((admin, key) => (
                                                                    key < 10 && <Link to={`/member/${admin.user.id}/profile`}><img
                                                                        src={admin.user.photo
                                                                            ? `https://buzzinguniverse.com/backend/${admin.user.photo}`
                                                                            : "/images/b.png"} alt={admin.user.first_name} /></Link>
                                                                ))
                                                            }
                                                        </div>
                                                        <h4>{group.privacy} {entityLabel} / {memberCounts[group.id] ?? '...'} {memberCounts[group.id] === 1 ? 'Follower' : 'followers'}</h4>
                                                        <div className="search-groups-btn">
                                                            {isCompany && group.url
                                                                ? <a href={group.url} target="_blank" rel="noopener noreferrer">View {entityLabel}</a>
                                                                : <Link to={`/company/${group.id}/${encodeURIComponent(group.name.replace(/\s+/g, '-').toLowerCase())}`}>View {entityLabel}</Link>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                );
                                            })
                                            ) : (
                                                <div className="col-12 text-center py-5">
                                                    <h5 className="text-muted">
                                                        No {activeTab === 'groups' ? 'groups' : activeTab === 'companies' ? 'companies' : 'results'} found
                                                    </h5>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="search-groups-pages-number mt-4 d-flex justify-content-center">
                                    {renderPagination()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



        </div>
    )
}

export default Group
